function toggleButton() {
  const checkbox = document.querySelector('#agree-sidecart');
  const checkoutButton = document.querySelector('.btn-checkout-js');
  const errorMessage = document.querySelector('.js-threshold_message');

  if (checkbox.checked) {
    checkoutButton.classList.remove('button-disabled');
    errorMessage.style.display = 'none';
  } else {
    checkoutButton.classList.add('button-disabled');
  }
}

/**
 * Open and close side cart with various buttons
 */
export const checkValidation = () => {
  const checkbox = document.querySelector('#agree-sidecart');
  const checkoutForm = document.querySelector('#checkout-form');

  toggleButton();

  checkbox.addEventListener('change', () => toggleButton());

  checkoutForm.addEventListener('submit', function (event) {
    const checkoutButton = document.querySelector('.btn-checkout-js');
    const errorMessage = document.querySelector('.js-threshold_message');

    if (checkoutButton.classList.contains('button-disabled')) {
      event.preventDefault();
      errorMessage.style.display = 'flex';
    }
  });
};
